var React = require('react');

function TagIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Workplaces-Homepage","transform":"translate(-786.000000, -212.000000)","fill":"#000000"},React.createElement("g",{"id":"Company-/-Wonder","transform":"translate(170.000000, 180.000000)"},React.createElement("g",{"id":"Meta"},React.createElement("g",{"id":"Industry","transform":"translate(616.000000, 30.000000)"},React.createElement("path",{"d":"M9,5.6 L9,2 L0,2 L0,18.2 L18,18.2 L18,5.6 L9,5.6 Z M3.6,16.4 L1.8,16.4 L1.8,14.6 L3.6,14.6 L3.6,16.4 Z M3.6,12.8 L1.8,12.8 L1.8,11 L3.6,11 L3.6,12.8 Z M3.6,9.2 L1.8,9.2 L1.8,7.4 L3.6,7.4 L3.6,9.2 Z M3.6,5.6 L1.8,5.6 L1.8,3.8 L3.6,3.8 L3.6,5.6 Z M7.2,16.4 L5.4,16.4 L5.4,14.6 L7.2,14.6 L7.2,16.4 Z M7.2,12.8 L5.4,12.8 L5.4,11 L7.2,11 L7.2,12.8 Z M7.2,9.2 L5.4,9.2 L5.4,7.4 L7.2,7.4 L7.2,9.2 Z M7.2,5.6 L5.4,5.6 L5.4,3.8 L7.2,3.8 L7.2,5.6 Z M16.2,16.4 L9,16.4 L9,14.6 L10.8,14.6 L10.8,12.8 L9,12.8 L9,11 L10.8,11 L10.8,9.2 L9,9.2 L9,7.4 L16.2,7.4 L16.2,16.4 Z M14.4,9.2 L12.6,9.2 L12.6,11 L14.4,11 L14.4,9.2 Z M14.4,12.8 L12.6,12.8 L12.6,14.6 L14.4,14.6 L14.4,12.8 Z","id":"Shape"})))))));
}

TagIcon.defaultProps = {"width":"18px","height":"17px","viewBox":"0 0 18 17","version":"1.1","xlinkHref":"http://www.w3.org/1999/xlink"};

module.exports = TagIcon;

TagIcon.default = TagIcon;



//////////////////
// WEBPACK FOOTER
// ./src/icons/TagIcon.svg
// module id = 432
// module chunks = 213534597649335